import DeleteNoteDialog from './DeleteNoteDialog.view';

export default DeleteNoteDialog;
